<template>
  <smd-one-col-layout>
    <smd-header slot="header" nav>
      <span class="ns-icon-ico028"
            slot="left-actions"
            @click="goBack"/>
      <p class="Title3 gray-400">On-Demand Details</p>
      <span class="ns-icon-ico001"
            slot="right-actions">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </smd-header>

    <smd-loader v-if="!initialLoad" :image="$options.Logo"/>

    <component v-if="status"
               :is="activeComponent"
               @set-loading="setLoading"/>
  </smd-one-col-layout>
</template>

<script>
  import {mapActions} from 'vuex';
  import {
    HOME_ROUTE,
    ERROR_ROUTE,
  } from '@/router/routes';
  import {
    ONDEMAND_STATUSES,
    ONDEMAND_CANCELLED_STATUSES,
  } from '@/reference/ondemand.js';
  import Pending from '@/views/ondemand/views/pending.vue';
  import AwaitingPayment from '@/views/ondemand/views/awaiting-payment.vue';
  import Accepted from '@/views/ondemand/views/accepted.vue';
  import CancelledRejected from '@/views/ondemand/views/cancelled-rejected.vue';
  import {OnDemandService} from '@/services/ondemand';
  import Logo from '@/assets/icons/now-serving-heart.svg';
  import {
    ACTION_SET_OD_BOOKING_DETAILS,
    ACTION_RESET_OD_BOOKING_DETAILS,
  } from '@/store/types';
  import OnDemandMixin from '@/mixins/ondemand-mixin';

  export default {
    name: 'root-ondemand',
    props: {
      bookingID: {type: String},
    },
    mixins: [
      OnDemandMixin,
    ],
    data() {
      return {
        status: null,
        initialLoad: false,
        refIntervalCheckODStatus: null,
      }
    },
    computed: {
      activeComponent() {
        const ONDEMAND_STATUS_PAGE = {
          [ONDEMAND_STATUSES.PENDING]: Pending,
          [ONDEMAND_STATUSES.PAYMENT]: AwaitingPayment,
          [ONDEMAND_STATUSES.ACCEPT]: Accepted,
        };

        if (ONDEMAND_STATUS_PAGE[this.status]) {
          return ONDEMAND_STATUS_PAGE[this.status];
        }

        return CancelledRejected;
      },
    },
    mounted() {
      this.getOnDemandStatus();
      this.startIntervalCheckODStatus();
    },
    destroyed() {
      clearInterval(this.refIntervalCheckODStatus);
      this.resetODBookingDetials();
    },
    methods: {
      ...mapActions({
        setODBookingDetails: ACTION_SET_OD_BOOKING_DETAILS,
        resetODBookingDetials: ACTION_RESET_OD_BOOKING_DETAILS,
      }),
      onODBookingAccept({requestid}) {
        if (requestid === this.bookingID) {
          this.getOnDemandStatus();
        }
      },
      onODBookingReject({requestid}) {
        if (requestid === this.bookingID) {
          this.getOnDemandStatus();
        }
      },
      async getOnDemandStatus() {
        this.initialLoad = true;

        try {
          const {data} = await OnDemandService.getBookingDetails(this.bookingID);

          if (data.result !== 1) throw Error();

          this.setODBookingDetails(data);
          this.status = data.status;

          if (ONDEMAND_CANCELLED_STATUSES.includes(data.status)) {
            clearInterval(this.refIntervalCheckODStatus);
          }
        } catch (err) {
          console.log(err);
          this.$router.push({name: ERROR_ROUTE});
        }
      },
      startIntervalCheckODStatus() {
        this.refIntervalCheckODStatus = setInterval(() => {
          this.getOnDemandStatus();
        }, 15000);
      },
      goBack() {
        this.$router.push({name: HOME_ROUTE});
      },
      setLoading(val) {
        this.loading = val;
      },
    },
    Logo,
  }
</script>
